import { reduxRoutes } from "./routes";
import IS_CLIENT_RENDERED from "../isClientRendered";

export const getRouter = (req) => {
    if (IS_CLIENT_RENDERED) {
        //client
        const routerForBrowser = require("redux-little-router").routerForBrowser;
        const { middleware, enhancer } = routerForBrowser({ routes: reduxRoutes });

        return { middleware, enhancer };
    }
    //server
    const routerForExpress = require("redux-little-router").routerForExpress;
    const { middleware, enhancer } = routerForExpress({ routes: reduxRoutes, request: req });
    return { middleware, enhancer };
}


// WEBPACK FOOTER //
// ./src/util/Router/index.js